import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    presupuestoInterno: {},
    ordenTrabajo: {},

    id: 0,
    presupuestoInternoId: 0,
    rubroTrabajo: '',
    titulo: '',
    descripcion: '',
    descripcionProduccion: '',
    cantidad: 0,
    moneda: '',
    costoEstimadoTotal: 0,
    // costoEstimadoTotalPesos: 0,
    costoProveedor: 0,
    costoFinal: 0,
    costoUnitarioEstimado: 0,
    costoUnitarioProveedor: 0,
    costoUnitarioFinal: 0,
    rowVersion: null,

    subtrabajos: [],

    readOnly: false,
    certificado: false,
    presupuestoCerrado: false,

    ordenSubtrabajoSeleccionado: null,

    subtrabajosDatos: [],
    subtrabajosDatosTotales: [],

    dirty: false,
};

const mutations = {
    updateField,

    'INICIALIZAR_ORDEN_TRABAJO' (state, params) {
        state.id = params.ordenTrabajoId;
        state.presupuestoInterno = params.presupuestoInterno;
        
        state.ordenTrabajo = {};
        state.presupuestoInternoId = 0;
        state.cliente = '';
        state.accion = '';
        state.rubroTrabajo = '';
        state.titulo = '';
        state.descripcion = '';
        state.descripcionProduccion = '';
        state.cantidad = 0;
        state.moneda = '';
        state.costoEstimadoTotal = 0;
        // state.costoEstimadoTotalPesos = 0;
        state.costoProveedor = 0;
        state.costoFinal = 0;
        state.costoUnitarioProveedor = 0;
        state.costoUnitarioFinal = 0;
        state.rowVersion = null;

        state.readOnly = false;
        state.certificado = false;
        state.presupuestoCerrado = false;

        state.dirty = false;
    },
    'REINICIALIZAR_ORDEN_TRABAJO' (state) {
        state.ordenTrabajo = {};
        state.presupuestoInternoId = 0;
        state.cliente = '';
        state.accion = '';
        state.rubroTrabajo = '';
        state.titulo = '';
        state.descripcion = '';
        state.descripcionProduccion = '';
        state.cantidad = 0;
        state.moneda = '';
        state.costoEstimadoTotal = 0;
        // state.costoEstimadoTotalPesos = 0;
        state.costoProveedor = 0;
        state.costoFinal = 0;
        state.costoUnitarioProveedor = 0;
        state.costoUnitarioFinal = 0;
        state.rowVersion = null;

        state.readOnly = false;
        state.certificado = false;
        state.presupuestoCerrado = false;

        state.dirty = false;
    },
    'SET_ORDEN_TRABAJO' (state, ordenTrabajo) {
        //state.ordenTrabajo = orden;
        state.presupuestoInternoId = ordenTrabajo.presupuestoInternoId;
        state.rubroTrabajo = ordenTrabajo.rubroTrabajo.trim();
        state.titulo = ordenTrabajo.titulo.trim();
        state.descripcion= ordenTrabajo.descripcion.trim();
        state.descripcionProduccion = ordenTrabajo.descripcionProduccion.trim();
        state.cantidad= parseFloat(ordenTrabajo.cantidad);
        state.moneda = ordenTrabajo.moneda.trim();
        state.costoEstimadoTotal= parseFloat(ordenTrabajo.costoEstimadoTotal);
        // state.costoEstimadoTotalPesos= parseFloat(ordenTrabajo.costoEstimadoTotal);
        state.costoProveedor= parseFloat(ordenTrabajo.costoProveedor);
        state.costoFinal= parseFloat(ordenTrabajo.costoFinal);
        state.costoUnitarioProveedor = helpers.methods.roundToTwo(parseFloat(ordenTrabajo.costoProveedor) / parseFloat(ordenTrabajo.cantidad));
        state.costoUnitarioFinal = helpers.methods.roundToTwo(parseFloat(ordenTrabajo.costoFinal) / parseFloat(ordenTrabajo.cantidad));
        state.rowVersion = ordenTrabajo.rowVersion;

        state.subtrabajos= ordenTrabajo.subtrabajos;
        /* Control del estado del renglon */
        state.subtrabajos.forEach(subtrabajo => subtrabajo.dirty = false);
        
        setSubtrabajosDatos(state);

        state.readOnly = (/true/i).test(ordenTrabajo.certificado) || (/true/i).test(ordenTrabajo.presupuestoCerrado);
        state.certificado = (/true/i).test(ordenTrabajo.certificado);
        state.presupuestoCerrado = (/true/i).test(ordenTrabajo.presupuestoCerrado);

        state.dirty = false;
    },

    'SELECT_ORDEN_SUBTRABAJO' (state, ordenSubtrabajo) {
        state.ordenSubtrabajoSeleccionado = ordenSubtrabajo;
    },
    'ADD_ORDEN_SUBTRABAJO' (state, ordenSubtrabajo) {
        ordenSubtrabajo.ordenProveedorId = 0;
        ordenSubtrabajo.evaluada = false;
        ordenSubtrabajo.noEvaluar = false;
        ordenSubtrabajo.dirty = true;
        state.subtrabajos.push(ordenSubtrabajo);

        setSubtrabajosDatos(state);
        state.dirty = true;
    },
    'UPDATE_ORDEN_SUBTRABAJO' (state, ordenSubtrabajo) {
        state.ordenSubtrabajoSeleccionado.articuloTipoId = ordenSubtrabajo.articuloTipoId;
        state.ordenSubtrabajoSeleccionado.articuloTipo = ordenSubtrabajo.articuloTipo;
        state.ordenSubtrabajoSeleccionado.rubroTrabajoId = ordenSubtrabajo.rubroTrabajoId;
        state.ordenSubtrabajoSeleccionado.rubroTrabajo = ordenSubtrabajo.rubroTrabajo;
        state.ordenSubtrabajoSeleccionado.proveedorId = ordenSubtrabajo.proveedorId;
        state.ordenSubtrabajoSeleccionado.proveedor = ordenSubtrabajo.proveedor;
        state.ordenSubtrabajoSeleccionado.cantidad = ordenSubtrabajo.cantidad;
        state.ordenSubtrabajoSeleccionado.monedaId = ordenSubtrabajo.monedaId;
        state.ordenSubtrabajoSeleccionado.moneda = ordenSubtrabajo.moneda;
        state.ordenSubtrabajoSeleccionado.monedaAbreviacion = ordenSubtrabajo.monedaAbreviacion;
        state.ordenSubtrabajoSeleccionado.costo = ordenSubtrabajo.costo;
        state.ordenSubtrabajoSeleccionado.costoTotal = ordenSubtrabajo.costoTotal;
        state.ordenSubtrabajoSeleccionado.costoUnitario = ordenSubtrabajo.costoUnitario;
        state.ordenSubtrabajoSeleccionado.diasProduccion = ordenSubtrabajo.diasProduccion;
        state.ordenSubtrabajoSeleccionado.logistica = (/true/i).test(ordenSubtrabajo.logistica);
        state.ordenSubtrabajoSeleccionado.costoRemitos = (/true/i).test(ordenSubtrabajo.costoRemitos);
        state.ordenSubtrabajoSeleccionado.observaciones = ordenSubtrabajo.observaciones;
        state.ordenSubtrabajoSeleccionado.dirty = true;
        
        setSubtrabajosDatos(state);

        state.dirty = true;
    },
    'DELETE_ORDEN_SUBTRABAJO' (state) {
        let itemKey = state.subtrabajos
            .findIndex(subtrabajo => subtrabajo == state.ordenSubtrabajoSeleccionado);

        if (itemKey != -1) {
            state.subtrabajos.splice(itemKey, 1);
            state.ordenSubtrabajoSeleccionado = null;
        }
        setSubtrabajosDatos(state);
        state.dirty = true;
    },
    'UPDATE_ORDEN_SUBTRABAJO_DATOS' (state, params) {
        let ordenSubtrabajo = state.subtrabajos
            .find(subtrabajo => subtrabajo == params.ordenSubtrabajo);
        if (ordenSubtrabajo) {
            ordenSubtrabajo.cantidad = params.cantidad;
            ordenSubtrabajo.diasProduccion = params.diasProduccion;
            ordenSubtrabajo.dirty = true;
            
            if (ordenSubtrabajo.costoUnitario) {
                ordenSubtrabajo.costoTotal = helpers.methods.roundToTwo(ordenSubtrabajo.costo * ordenSubtrabajo.cantidad);
            } else {
                ordenSubtrabajo.costo = helpers.methods.roundToTwo(ordenSubtrabajo.costoTotal / ordenSubtrabajo.cantidad);
            }

            setSubtrabajosDatos(state);
            state.dirty = true;
        }
    },
    'UPDATE_ORDEN_SUBTRABAJO_COSTO' (state, params) {
        let ordenSubtrabajo = state.subtrabajos
            .find(subtrabajo => subtrabajo == params.ordenSubtrabajo);
        if (ordenSubtrabajo) {
            let costoTotal = 0;
            costoTotal = helpers.methods.roundToTwo(params.costo * ordenSubtrabajo.cantidad);

            ordenSubtrabajo.costo = params.costo;
            ordenSubtrabajo.costoTotal = costoTotal;
            ordenSubtrabajo.dirty = true;
            
            setSubtrabajosDatos(state);
            state.dirty = true;
        }
    },
    'UPDATE_ORDEN_SUBTRABAJO_COSTO_TOTAL' (state, params) {
        let ordenSubtrabajo = state.subtrabajos
            .find(subtrabajo => subtrabajo == params.ordenSubtrabajo);
        if (ordenSubtrabajo) {
            let costo = 0;
            costo = helpers.methods.roundToTwo(params.costoTotal / ordenSubtrabajo.cantidad);

            ordenSubtrabajo.costo = costo;
            ordenSubtrabajo.costoTotal = params.costoTotal;
            ordenSubtrabajo.dirty = true;
            
            setSubtrabajosDatos(state);
            state.dirty = true;
        }
    },
    'DELETE_ORDEN_PROVEEDOR' (state, ordenProveedorId) {
        state.subtrabajos.forEach(subtrabajo => {
            if (subtrabajo.ordenProveedorId == ordenProveedorId) {
                subtrabajo.ordenProveedorId = 0;
                subtrabajo.evaluada = false;
                // subtrabajo.noEvaluar = false;
            }
        });

        setSubtrabajosDatos(state);
    },
    'SET_ORDEN_PROVEEDOR_EVALUADA' (state, ordenProveedorId) {
        state.subtrabajos.forEach(subtrabajo => {
            if (subtrabajo.ordenProveedorId == ordenProveedorId) {
                subtrabajo.evaluada = true;
            }
        });

        setSubtrabajosDatos(state);
    },
    'RESET_DIRTY' (state) {
        state.dirty = false;
    },
};

function setSubtrabajosDatos(state) {
    state.subtrabajosDatos = [];
    state.subtrabajosDatosTotales = [];

    state.costoProveedor = 0;

    if (state.subtrabajos) {
        state.subtrabajos.forEach(subtrabajo => {
            state.subtrabajosDatos.push({
                ordenSubtrabajo: subtrabajo,

                ordenSubtrabajoId: subtrabajo.ordenSubtrabajoId,
                rubro: subtrabajo.rubroTrabajo,
                nombre: subtrabajo.articuloTipo,
                cantidad: subtrabajo.cantidad,
                monedaId: subtrabajo.monedaId,
                moneda: subtrabajo.monedaAbreviacion.trim(),
                proveedorId: subtrabajo.proveedorId,
                proveedor: subtrabajo.proveedor,
                costo: subtrabajo.costo,
                costoTotal: subtrabajo.costoTotal,
                costoUnitario: subtrabajo.costoUnitario,
                diasProduccion: subtrabajo.diasProduccion,
                logistica: (/true/i).test(subtrabajo.logistica),
                costoRemitos: (/true/i).test(subtrabajo.costoRemitos),
                observaciones: subtrabajo.observaciones.trim(),
                ordenProveedorId: subtrabajo.ordenProveedorId,
                evaluada: (/true/i).test(subtrabajo.evaluada),
                noEvaluar: (/true/i).test(subtrabajo.noEvaluar),
                remitos: (/true/i).test(subtrabajo.remitos),
                dirty: subtrabajo.dirty,
                _showDetails: Boolean(true),
                selected: false,
            });
        });

        let monedaCotizacion = 0;
        if (state.presupuestoInterno) {
            if (state.presupuestoInterno.monedaCotizacion) {
                monedaCotizacion = parseFloat(state.presupuestoInterno.monedaCotizacion);
            }
        }

        let costoTotal = state.subtrabajos
            .reduce((costoTotal, subtrabajo) => {
                let costoSubtrabajo = parseFloat(subtrabajo.costoTotal);
                if (subtrabajo.monedaId == 102) {
                    costoSubtrabajo = helpers.methods.roundToTwo(parseFloat(subtrabajo.costoTotal) * parseFloat(monedaCotizacion));
                }
                return costoTotal + costoSubtrabajo;
            }, 0);
        
        let costoUnitario = helpers.methods.roundToTwo(costoTotal / state.cantidad);
        // state.costoProveedor = costoUnitario;
        
        state.costoProveedor = costoTotal;
        state.costoUnitarioProveedor = costoUnitario;

        state.subtrabajosDatosTotales.push({
            totales: 'TOTALES',
            // costo: costoUnitario,
            costoTotal: parseFloat(costoTotal)
        })
    }
}

const getters = {
    getField,

    getOrdenTrabajo (state) {
        return state.ordenTrabajo;
    },

    isOrdenSubtrabajoSeleccionada (state) {
        return state.ordenSubtrabajoSeleccionado ? true : false;
    },
};

const actions = {
    inicializar ( { commit, rootGetters }, params ) {
        return new Promise((resolve, reject) => {
            params.presupuestoInterno = null;
            if ((/true/i).test(params.loadPresupuesto)) {
                params.presupuestoInterno = rootGetters['presupuestointernoproduccion/presupuestoInterno'];
            }

            commit('INICIALIZAR_ORDEN_TRABAJO', params);

            if (params.ordenTrabajoId != 0) {
                apiAxios.get(`ordenestrabajos/${params.ordenTrabajoId}/produccion`)
                    .then(res => {
                        commit('SET_ORDEN_TRABAJO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            } 
        })
    },
    reinicializar ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('REINICIALIZAR_ORDEN_TRABAJO');

            if (state.id != 0) {
                apiAxios.get(`ordenestrabajos/${state.id}/produccion`) 
                    .then(res => {
                        commit('SET_ORDEN_TRABAJO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            } 
        })
    },
    save ( { commit, state }, params ) {
        return new Promise((resolve, reject) => {
            let update = true;
            let errorMessage = '';
            
            state.subtrabajos.forEach(subtrabajo => {
                if (isNaN(subtrabajo.costo)) {
                    update = false;
                    errorMessage = "Uno o más de los subtrabajos no tiene definido un costo válido.";
                }
            });

            if (update) {
                let subtrabajos = [];
                state.subtrabajos.forEach(subtrabajo => {
                    subtrabajos.push({
                        ordenSubtrabajoId: subtrabajo.ordenSubtrabajoId,
                        articuloTipoId: subtrabajo.articuloTipoId,
                        cantidad: subtrabajo.cantidad,
                        monedaId: subtrabajo.monedaId,
                        proveedorId: subtrabajo.proveedorId,
                        costo: subtrabajo.costo,
                        costoTotal: subtrabajo.costoTotal,
                        costoUnitario: subtrabajo.costoUnitario,
                        diasProduccion: subtrabajo.diasProduccion,
                        logistica: (/true/i).test(subtrabajo.logistica),
                        costoRemitos: (/true/i).test(subtrabajo.costoRemitos),
                        observaciones: subtrabajo.observaciones.trim(),
                        rowVersion: subtrabajo.rowVersion,
                    })
                });

                let ordenTrabajo= {
                    costoEstimadoTotal: state.costoEstimadoTotal,
                    descripcionProduccion: state.descripcionProduccion,
                    rowVersion: state.rowVersion,
                    subtrabajos: subtrabajos
                };
                
                let url = `ordenestrabajos/${state.id}`;
                if (params) {
                    if (params.saveContinue) {
                        url += '/sc';
                    }
                }

                apiAxios.post(url, ordenTrabajo)
                    .then(res => {
                        if (params) {
                            if (params.saveContinue) {
                                // commit('SET_ORDEN_TRABAJO_ID', res.data);
                                commit('SET_ORDEN_TRABAJO', res.data);
                            }
                        }
                        commit('RESET_DIRTY');
                        
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)))                    
                } else {
                    reject(errorMessage);
                }
        })
    },
    
    selectOrdenSubtrabajo: ({commit}, ordenSubtrabajo) => {
        return new Promise((resolve, reject) => {
            commit('SELECT_ORDEN_SUBTRABAJO', ordenSubtrabajo);
            resolve();
        })
    },
    addOrdenSubtrabajo: ({commit}, ordenSubtrabajo) => {
        return new Promise((resolve, reject) => {
            commit('ADD_ORDEN_SUBTRABAJO', ordenSubtrabajo);
            resolve();
        })
    },
    updateOrdenSubtrabajo: ({commit}, ordenSubtrabajo) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_SUBTRABAJO', ordenSubtrabajo);
            resolve();
        })
    },
    deleteOrdenSubtrabajo: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('DELETE_ORDEN_SUBTRABAJO');
            resolve();
        })
    },
    updateOrdenSubtrabajoDatos: ({commit}, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_SUBTRABAJO_DATOS', params);
            resolve();
        })
    },
    updateOrdenSubtrabajoCosto: ({commit}, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_SUBTRABAJO_COSTO', params);
            resolve();
        })
    },
    updateOrdenSubtrabajoCostoTotal: ({commit}, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_SUBTRABAJO_COSTO_TOTAL', params);
            resolve();
        })
    },
    deleteOrdenProveedor: ({commit}, ordenProveedorId) => {
        return new Promise((resolve, reject) => {
            commit('DELETE_ORDEN_PROVEEDOR', ordenProveedorId);
            resolve();
        })
    },
    setOrdenProveedorEvaluada: ({commit}, ordenProveedorId) => {
        return new Promise((resolve, reject) => {
            commit('SET_ORDEN_PROVEEDOR_EVALUADA', ordenProveedorId);
            resolve();
        })
    },
    resetDirty: ({ commit }) => {
        return new Promise((resolve, reject) => {
            commit('RESET_DIRTY');
            resolve();
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}